
import * as ipxRuntime$VjUzDENllf from '/usr/src/app/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 552,
    "md": 992,
    "lg": 1330,
    "xl": 1600,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "portal.geobon.org",
    "chm-cbd.net",
    "be.bl2.chm-cbd.net",
    "lk.bl2.cbddev.xyz",
    "acb.bl2.cbddev.xyz",
    "be.bl2.cbddev.xyz",
    "cbd.int",
    "www.cbd.int",
    "panorama.solutions",
    "scbd.atlassian.net",
    "han-demo.bl2.chm-cbd.net",
    "demo.bl2.chm-cbd.net",
    "training.bl2.chm-cbd.net",
    "acb.bl2.chm-cbd.net",
    "ad.bl2.chm-cbd.net",
    "ae.bl2.chm-cbd.net",
    "af.bl2.chm-cbd.net",
    "ag.bl2.chm-cbd.net",
    "al.bl2.chm-cbd.net",
    "am.bl2.chm-cbd.net",
    "ao.bl2.chm-cbd.net",
    "ar.bl2.chm-cbd.net",
    "at.bl2.chm-cbd.net",
    "au.bl2.chm-cbd.net",
    "az.bl2.chm-cbd.net",
    "ba.bl2.chm-cbd.net",
    "bb.bl2.chm-cbd.net",
    "bd.bl2.chm-cbd.net",
    "bf.bl2.chm-cbd.net",
    "bg.bl2.chm-cbd.net",
    "bh.bl2.chm-cbd.net",
    "bi.bl2.chm-cbd.net",
    "bj.bl2.chm-cbd.net",
    "bn.bl2.chm-cbd.net",
    "bo.bl2.chm-cbd.net",
    "br.bl2.chm-cbd.net",
    "bs.bl2.chm-cbd.net",
    "bt.bl2.chm-cbd.net",
    "bw.bl2.chm-cbd.net",
    "by.bl2.chm-cbd.net",
    "bz.bl2.chm-cbd.net",
    "ca.bl2.chm-cbd.net",
    "cd.bl2.chm-cbd.net",
    "cf.bl2.chm-cbd.net",
    "cg.bl2.chm-cbd.net",
    "ch.bl2.chm-cbd.net",
    "ci.bl2.chm-cbd.net",
    "ck.bl2.chm-cbd.net",
    "cl.bl2.chm-cbd.net",
    "cm.bl2.chm-cbd.net",
    "cn.bl2.chm-cbd.net",
    "co.bl2.chm-cbd.net",
    "cr.bl2.chm-cbd.net",
    "cu.bl2.chm-cbd.net",
    "cv.bl2.chm-cbd.net",
    "cy.bl2.chm-cbd.net",
    "cz.bl2.chm-cbd.net",
    "de.bl2.chm-cbd.net",
    "dj.bl2.chm-cbd.net",
    "dk.bl2.chm-cbd.net",
    "dm.bl2.chm-cbd.net",
    "do.bl2.chm-cbd.net",
    "dz.bl2.chm-cbd.net",
    "ec.bl2.chm-cbd.net",
    "ee.bl2.chm-cbd.net",
    "eg.bl2.chm-cbd.net",
    "er.bl2.chm-cbd.net",
    "es.bl2.chm-cbd.net",
    "et.bl2.chm-cbd.net",
    "eu.bl2.chm-cbd.net",
    "fi.bl2.chm-cbd.net",
    "fj.bl2.chm-cbd.net",
    "fm.bl2.chm-cbd.net",
    "fr.bl2.chm-cbd.net",
    "ga.bl2.chm-cbd.net",
    "gb.bl2.chm-cbd.net",
    "gd.bl2.chm-cbd.net",
    "ge.bl2.chm-cbd.net",
    "gh.bl2.chm-cbd.net",
    "gm.bl2.chm-cbd.net",
    "gn.bl2.chm-cbd.net",
    "gq.bl2.chm-cbd.net",
    "gr.bl2.chm-cbd.net",
    "gt.bl2.chm-cbd.net",
    "gw.bl2.chm-cbd.net",
    "gy.bl2.chm-cbd.net",
    "hn.bl2.chm-cbd.net",
    "hr.bl2.chm-cbd.net",
    "ht.bl2.chm-cbd.net",
    "hu.bl2.chm-cbd.net",
    "id.bl2.chm-cbd.net",
    "ie.bl2.chm-cbd.net",
    "il.bl2.chm-cbd.net",
    "in.bl2.chm-cbd.net",
    "iq.bl2.chm-cbd.net",
    "ir.bl2.chm-cbd.net",
    "is.bl2.chm-cbd.net",
    "it.bl2.chm-cbd.net",
    "jm.bl2.chm-cbd.net",
    "jo.bl2.chm-cbd.net",
    "jp.bl2.chm-cbd.net",
    "ke.bl2.chm-cbd.net",
    "kg.bl2.chm-cbd.net",
    "kh.bl2.chm-cbd.net",
    "ki.bl2.chm-cbd.net",
    "km.bl2.chm-cbd.net",
    "kn.bl2.chm-cbd.net",
    "kp.bl2.chm-cbd.net",
    "kr.bl2.chm-cbd.net",
    "kw.bl2.chm-cbd.net",
    "kz.bl2.chm-cbd.net",
    "la.bl2.chm-cbd.net",
    "lb.bl2.chm-cbd.net",
    "lc.bl2.chm-cbd.net",
    "li.bl2.chm-cbd.net",
    "lk.bl2.chm-cbd.net",
    "lr.bl2.chm-cbd.net",
    "ls.bl2.chm-cbd.net",
    "lt.bl2.chm-cbd.net",
    "lu.bl2.chm-cbd.net",
    "lv.bl2.chm-cbd.net",
    "ly.bl2.chm-cbd.net",
    "ma.bl2.chm-cbd.net",
    "mc.bl2.chm-cbd.net",
    "md.bl2.chm-cbd.net",
    "me.bl2.chm-cbd.net",
    "mg.bl2.chm-cbd.net",
    "mh.bl2.chm-cbd.net",
    "mk.bl2.chm-cbd.net",
    "ml.bl2.chm-cbd.net",
    "mm.bl2.chm-cbd.net",
    "mn.bl2.chm-cbd.net",
    "mr.bl2.chm-cbd.net",
    "mt.bl2.chm-cbd.net",
    "mu.bl2.chm-cbd.net",
    "mv.bl2.chm-cbd.net",
    "mw.bl2.chm-cbd.net",
    "mx.bl2.chm-cbd.net",
    "my.bl2.chm-cbd.net",
    "mz.bl2.chm-cbd.net",
    "na.bl2.chm-cbd.net",
    "ne.bl2.chm-cbd.net",
    "ng.bl2.chm-cbd.net",
    "ni.bl2.chm-cbd.net",
    "nl.bl2.chm-cbd.net",
    "no.bl2.chm-cbd.net",
    "np.bl2.chm-cbd.net",
    "nr.bl2.chm-cbd.net",
    "nu.bl2.chm-cbd.net",
    "nz.bl2.chm-cbd.net",
    "om.bl2.chm-cbd.net",
    "pa.bl2.chm-cbd.net",
    "pe.bl2.chm-cbd.net",
    "pg.bl2.chm-cbd.net",
    "ph.bl2.chm-cbd.net",
    "pk.bl2.chm-cbd.net",
    "pl.bl2.chm-cbd.net",
    "ps.bl2.chm-cbd.net",
    "pt.bl2.chm-cbd.net",
    "pw.bl2.chm-cbd.net",
    "py.bl2.chm-cbd.net",
    "qa.bl2.chm-cbd.net",
    "ro.bl2.chm-cbd.net",
    "rs.bl2.chm-cbd.net",
    "ru.bl2.chm-cbd.net",
    "rw.bl2.chm-cbd.net",
    "sa.bl2.chm-cbd.net",
    "sb.bl2.chm-cbd.net",
    "sc.bl2.chm-cbd.net",
    "sd.bl2.chm-cbd.net",
    "se.bl2.chm-cbd.net",
    "sg.bl2.chm-cbd.net",
    "si.bl2.chm-cbd.net",
    "sk.bl2.chm-cbd.net",
    "sl.bl2.chm-cbd.net",
    "sm.bl2.chm-cbd.net",
    "sn.bl2.chm-cbd.net",
    "so.bl2.chm-cbd.net",
    "sr.bl2.chm-cbd.net",
    "ss.bl2.chm-cbd.net",
    "st.bl2.chm-cbd.net",
    "sv.bl2.chm-cbd.net",
    "sy.bl2.chm-cbd.net",
    "sz.bl2.chm-cbd.net",
    "td.bl2.chm-cbd.net",
    "tg.bl2.chm-cbd.net",
    "th.bl2.chm-cbd.net",
    "tj.bl2.chm-cbd.net",
    "tl.bl2.chm-cbd.net",
    "tm.bl2.chm-cbd.net",
    "tn.bl2.chm-cbd.net",
    "to.bl2.chm-cbd.net",
    "tr.bl2.chm-cbd.net",
    "tt.bl2.chm-cbd.net",
    "tv.bl2.chm-cbd.net",
    "tz.bl2.chm-cbd.net",
    "ua.bl2.chm-cbd.net",
    "ug.bl2.chm-cbd.net",
    "us.bl2.chm-cbd.net",
    "uy.bl2.chm-cbd.net",
    "uz.bl2.chm-cbd.net",
    "va.bl2.chm-cbd.net",
    "vc.bl2.chm-cbd.net",
    "ve.bl2.chm-cbd.net",
    "vn.bl2.chm-cbd.net",
    "vu.bl2.chm-cbd.net",
    "ws.bl2.chm-cbd.net",
    "ye.bl2.chm-cbd.net",
    "za.bl2.chm-cbd.net",
    "zm.bl2.chm-cbd.net",
    "zw.bl2.chm-cbd.net"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "avif",
    "jpeg",
    "jpg",
    "png",
    "gif",
    "webp"
  ],
  "quality": 50
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$VjUzDENllf, defaults: {} }
}
        